/* tslint:disable */
/* eslint-disable */
/* @relayHash ce763b20821d14e7b6bf57428b4878ec */

import { ConcreteRequest } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type EditPersonalProfileInput = {
    userServiceId: string;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    currency?: Currency | null;
    measurementUnit?: MeasurementUnit | null;
    zipCode?: string | null;
    shareActivities?: boolean | null;
    clientMutationId?: string | null;
};
export type changeCurrencyMutationVariables = {
    input: EditPersonalProfileInput;
};
export type changeCurrencyMutationResponse = {
    readonly editPersonalProfile: {
        readonly user: {
            readonly profile: {
                readonly currency: Currency | null;
            } | null;
        } | null;
    } | null;
};
export type changeCurrencyMutation = {
    readonly response: changeCurrencyMutationResponse;
    readonly variables: changeCurrencyMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EditPersonalProfileInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "profile",
  "storageKey": null,
  "args": null,
  "concreteType": "Profile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "changeCurrencyMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "editPersonalProfile",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "EditPersonalProfilePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "changeCurrencyMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "editPersonalProfile",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "EditPersonalProfilePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "changeCurrencyMutation",
    "id": "ferrum/262.0.0-2020-04-28T16:33:21.478Z/changeCurrencyMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '217dffcd72e935f2b56dd37a4bfdc741';
export default node;
